import tgemPng from '/img/tgem.png';
import tgemWebp from '/img/tgem.webp';
import tgem3dPng from '/img/tgem-3d.png';
import tgem3dWebp from '/img/tgem-3d.webp';
import tgemBigPng from '/img/tgem-big.png';
import tgemBigWebp from '/img/tgem-big.webp';

export const tgemImages = {
  icon: {
    png: tgemPng,
    webp: tgemWebp,
  },
  iconLg: {
    png: tgemBigPng,
    webp: tgemBigWebp,
  },
  icon3d: {
    png: tgem3dPng,
    web: tgem3dWebp,
  },
} as const;
